import stock from '@/api/stock';
import { v1 as uuid } from 'uuid';
import * as types from './mutationTypes';

function fetchStockByAnchor(highlighted, params) {
  const query = {
    ...params,
    stock_id: highlighted.stock.gstock_id,
    stock_ics_type: highlighted.stock.ics_type,
    order_field: highlighted.field,
    order_direction: 'asc',
  };

  if (Array.isArray(params.districts) && params.districts.length > 0) {
    query.districts = params.districts.join(',');
  }
  return stock.getStocksByAnchor(query);
}

function fetchStockByFilter(params) {
  const query = { ...params };

  if (Array.isArray(params.districts) && params.districts.length > 0) {
    query.districts = params.districts.join(',');
  }
  return stock.getStocks(query);
}

function recordVisitedStock(recentStock, allRecentStocks) {
  const now = new Date();
  const recentVisitedStocks = [];
  allRecentStocks.unshift(recentStock);

  const addedStockId = {};
  allRecentStocks.forEach((tmpStock) => {
    const stockTime = new Date(tmpStock.visit_time);
    const diff = (now.getTime() - stockTime.getTime()) / 1000 / 60 / 60 / 24;

    if (diff <= 30) {
      // only add stock record under 30 days
      const stockDate = `${stockTime.getDate()}${stockTime.getMonth()}${stockTime.getFullYear()}`;
      if (!addedStockId[stockDate]) {
        // add stock record if date slot not exist
        addedStockId[stockDate] = [`${tmpStock.ics_type}${tmpStock.gstock_id}`];
        recentVisitedStocks.push(tmpStock);
      } else if (
        !addedStockId[stockDate].includes(
          `${tmpStock.ics_type}${tmpStock.gstock_id}`,
        )
      ) {
        // add stock record if no same stock of the same date
        addedStockId[stockDate].push(
          `${tmpStock.ics_type}${tmpStock.gstock_id}`,
        );
        recentVisitedStocks.push(tmpStock);
      }
    }
  });
  localStorage.setItem(
    'recentVisitedStocks',
    JSON.stringify(recentVisitedStocks),
  );
  return recentVisitedStocks;
}

// function recordFavoriteStock(favoriteStock, allFavoriteStocks) {
//   allFavoriteStocks.unshift(favoriteStock);

//   localStorage.setItem('favoriteStocks', JSON.stringify(allFavoriteStocks));
//   return allFavoriteStocks;
// }

// function removeFavoriteStock(targetStock, allFavoriteStocks) {
//   let newFavoriteStocksList = [];

//   newFavoriteStocksList = allFavoriteStocks.reduce((tmp, s) => {
//     if (
//       !(
//         targetStock.gstock_id === s.gstock_id &&
//         targetStock.ics_type === s.ics_type
//       )
//     ) {
//       tmp.push(s);
//     }
//     return tmp;
//   }, []);
//   localStorage.setItem('favoriteStocks', JSON.stringify(newFavoriteStocksList));
//   return newFavoriteStocksList;
// }

export default {
  setAutoSearch({ commit }, value) {
    commit(types.SET_AUTO_SEARCH, value);
  },
  searchStocks({ commit, state }, filters) {
    const fetchId = uuid();
    commit(types.START_FETCH_STOCKS, { filters, fetchId });

    const pagination = {
      pageSize: state.pageSize,
    };

    if (state.sorting) {
      pagination.order_field = state.sorting.field;
      pagination.order_direction = state.sorting.direction;
    }

    return fetchStockByFilter({
      ...state.filters,
      ...pagination,
    })
      .then((stocks) => {
        commit(types.SET_FETCHED_STOCKS, { stocks, fetchId });
      })
      .catch((e) => {
        commit(types.FETCH_STOCKS_ERROR, `failed get stocks: ${e}`);
      });
  },

  fetchMoreStocks({ commit, state, getters }, payload = {}) {
    commit(types.SET_PAGE_SIZE, 12);
    commit(types.START_FETCH_MORE_STOCKS);

    const direction = payload.direction || 'down';
    const pagination = {
      pageSize: state.pageSize,
      cursor: getters.endCursor,
    };
    if (direction === 'up') {
      const cursor = getters.frontCursor - state.pageSize - 1;
      if (cursor < 0) {
        pagination.pageSize = getters.frontCursor;
        pagination.cursor = 0;
      } else {
        pagination.cursor = cursor;
      }
    }

    if (state.sorting) {
      pagination.order_field = state.sorting.field;
      pagination.order_direction = state.sorting.direction;
    }

    fetchStockByFilter({
      ...state.filters,
      ...pagination,
    })
      .then((stocks) => {
        if (direction === 'up') {
          commit(types.PREPEND_FETCHED_STOCKS, stocks);
        } else {
          commit(types.APPEND_FETCHED_STOCKS, stocks);
        }
        return stocks;
      })
      .catch((e) => {
        commit(types.FETCH_STOCKS_ERROR, `failed get stocks: ${e}`);
      });
  },

  searchStocksByPaginatation({ commit, state }, payload) {
    const fetchId = uuid();

    commit(types.START_FETCH_PAGINATED_STOCKS, { fetchId });
    const pagination = {
      pageSize: state.pageSize,
      cursor: payload.offset,
    };
    if (state.sorting) {
      pagination.order_field = state.sorting.field;
      pagination.order_direction = state.sorting.direction;
    }
    return fetchStockByFilter({
      ...state.filters,
      ...pagination,
    })
      .then((stocks) => {
        commit(types.SET_FETCHED_PAGINATED_STOCKS, { stocks, fetchId });
      })
      .catch((e) => {
        commit(types.FETCH_STOCKS_ERROR, `failed get stocks: ${e}`);
      });
  },

  updateFilter({ dispatch, commit, state }, filters) {
    Object.keys(filters).forEach((filterKey) => {
      if (!filters[filterKey]) {
        commit(types.UNSET_FILTER, filterKey); // remove filter from state if value is null
      } else {
        commit(types.SET_FILTER, {
          [filterKey]: filters[filterKey],
        });
      }
    });
    const autoSearch = state.autoSearch;

    if (autoSearch) {
      return dispatch('searchStocks');
    }
    return true;
  },

  updateDistrictFilter({ dispatch, commit, state }, actions) {
    const districts = state.filters.districts || [];
    Object.keys(actions).forEach((distCode) => {
      const selected = actions[distCode];
      const idx = districts.findIndex(dc => dc === distCode);
      if (selected && idx === -1) {
        districts.push(distCode);
      }
      if (!selected && idx !== -1) {
        districts.splice(idx, 1);
      }
    });

    commit(types.SET_FILTER, { districts });

    return dispatch('searchStocks');
  },

  updateDistrictFilterNoSearch({ commit, state }, actions) {
    const districts = state.filters.districts || [];
    Object.keys(actions).forEach((distCode) => {
      const selected = actions[distCode];
      const idx = districts.findIndex(dc => dc === distCode);
      if (selected && idx === -1) {
        districts.push(distCode);
      }
      if (!selected && idx !== -1) {
        districts.splice(idx, 1);
      }
    });

    commit(types.SET_FILTER, { districts });
  },

  changeSorting({ dispatch, commit }, payload) {
    commit(types.CHANGE_SORTING, payload);

    return dispatch('searchStocks');
  },

  highlightStock({ commit, state }, payload) {
    commit(types.HIGHLIGHT_STOCK, payload);

    const fetchId = uuid();
    commit(types.START_FETCH_STOCKS, { fetchId });
    return fetchStockByAnchor(state.highlighted, state.filters)
      .then((stocks) => {
        commit(types.SET_FETCHED_STOCKS, { stocks, fetchId });
      })
      .catch((e) => {
        commit(types.FETCH_STOCKS_ERROR, `failed get stocks: ${e}`);
      });
  },

  visitStock({ commit, state }, payload) {
    const now = Date();
    const funcOptions = payload.options || {};
    const options = {
      markRecent: true,
      ...funcOptions,
    };

    if (options.markRecent) {
      const visitInfo = {
        ...payload.stock,
        thumbnail: payload.thumbnail,
        visit_time: now,
      };
      const newVisistedStock = recordVisitedStock(
        visitInfo,
        state.recentVisited,
      );

      commit(types.SET_RECENT_VISITED, newVisistedStock);
    }
  },

  appendFavorite({ commit, state }, payload) {
    const dedupFavoriteMap = [...state.favorite2, ...payload].reduce(
      (acc, curr) => {
        const propertyId = stock.formatPropertyIdForUrl(
          curr.ics_type,
          curr.gstock_id,
        );
        if (!acc[propertyId]) {
          Object.assign(acc, {
            [propertyId]: curr,
          });
        }
        return acc;
      },
      {},
    );

    const dedupFavorite = Object.values(dedupFavoriteMap);

    commit(types.SET_FAVORITE_2, dedupFavorite);
  },

  addStockToMyFavorite({ commit, state }, payload) {
    if (!window.IciPageModuleBookmarkApi) {
      return;
    }
    const propertyId = stock.formatPropertyIdForUrl(
      payload.stock.ics_type,
      payload.stock.gstock_id,
    );
    const collectionService = stock.txTypeToCollectionServiceMap(
      payload.stock.tx_type,
    );
    const currFavoriteStock = [...state.favorite2];
    const newFavoriteStock = [...currFavoriteStock, { ...payload.stock }];

    window.IciPageModuleBookmarkApi.add({
      propertyId,
      services:
        collectionService === 'buyrent' ? ['buy', 'rent'] : [collectionService],
      _export: {
        revert: () => {
          commit(types.SET_FAVORITE_2, currFavoriteStock);
        },
      },
    });
    commit(types.SET_FAVORITE_2, newFavoriteStock);
  },

  removeStockToMyFavorite({ commit, state }, payload) {
    if (!window.IciPageModuleBookmarkApi) {
      return;
    }
    const targetStock = { ...payload.stock };
    const propertyId = stock.formatPropertyIdForUrl(
      targetStock.ics_type,
      targetStock.gstock_id,
    );
    const collectionService = stock.txTypeToCollectionServiceMap(
      targetStock.tx_type,
    );
    const currFavoriteStock = [...state.favorite2];

    const newFavoriteStock = currFavoriteStock.reduce((tmp, s) => {
      if (
        !(
          targetStock.gstock_id === s.gstock_id &&
          targetStock.ics_type === s.ics_type
        )
      ) {
        tmp.push(s);
      }
      return tmp;
    }, []);

    window.IciPageModuleBookmarkApi.remove({
      propertyId,
      services: [collectionService],
      _export: {
        revert: () => {
          commit(types.SET_FAVORITE_2, currFavoriteStock);
        },
      },
    });

    commit(types.SET_FAVORITE_2, newFavoriteStock);
  },

  setPageSize({ commit }, value) {
    commit(types.SET_PAGE_SIZE, value);
  },

  fetchVisitedStock({ commit, state }) {
    let stockIds = [];
    if (state.recentVisited.length > 0) {
      stockIds = state.recentVisited.reduce((tmp, s) => {
        tmp.push(stock.getStockId(s));
        return tmp;
      }, []);

      if (stockIds.length > 0) {
        const query = {
          stock_ids: stockIds.join(','),
        };
        stock.getHistoryStocks(query).then((result) => {
          // console.log(result.stocks);
          commit(types.SET_FETCHED_RECENT_VISITED, result.stocks);
        });
      }
    }
  },

  fetchFavoriteStock({ commit, state }) {
    let stockIds = [];
    if (state.favorite.length > 0) {
      stockIds = state.favorite.reduce((tmp, s) => {
        tmp.push(stock.getStockId(s));
        return tmp;
      }, []);

      if (stockIds.length > 0) {
        const query = {
          stock_ids: stockIds.join(','),
        };
        stock.getHistoryStocks(query).then((result) => {
          // console.log(result.stocks);
          commit(types.SET_FETCHED_FAVORITE, result.stocks);
        });
      }
    }
  },
};
